import HoursRow from 'components/Content/Happening/StoreDetails/HoursInformation/HoursGrid/HoursRow/HoursRow';

export default HoursRow;
